import { render, staticRenderFns } from "./FreeBusTravelKicker.vue?vue&type=template&id=141bbe1c"
import script from "./FreeBusTravelKicker.vue?vue&type=script&lang=js"
export * from "./FreeBusTravelKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports